/* eslint-disable max-len */
export default (palette, typography) => ({
  // @theming labelText: Disable day background color, type: color
  background: palette.background,
  // TODO: remove this - unused
  border: palette.form.border,
  // @theming labelText: Cancel button text color, type: color
  cancelButtonColor: palette.primary.normal,
  // TODO: remove. This is a used property but it's impossible to have the cancel button be disabled
  cancelButtonColorDisabled: palette.grey.G300,
  // TODO: Remove unused
  cancelButtonColorHover: palette.primary.light,

  // TODO: this property is spread
  cellButtonSpan: {
    // @theming labelText: Day font size, type: pixel
    fontSize: 16,
    // @theming labelText: Day height, type: pixel
    height: 26,
    // @theming labelText: Day line height, type: string
    lineHeight: '28px',
    // @theming labelText: Day width, type: pixel
    width: 26,
  },

  // TODO: this property is spread
  // Cells Wrap
  cellsWrap: {},

  // Ash theme doesn't display chevron but still uses chevron class.
  // Margin set here to define space between dropdown and input
  chevron: {
    // @theming labelText: Popover top margin, type: pixel
    marginTop: 4,
  },

  chevronPointsDown: {
    // @theming labelText: Popover bottom margin, type: pixel
    marginBottom: 4,
  },

  dark: {
    // @theming labelText: Dark mode text input icon color, type: color
    inputIconButtonColor: palette.text.light,
  },
  // TODO: Remove un-used
  darkFocusColor: palette.focus.dark,

  dateSelect: {
    // @theming labelText: Dropdown background color, type: color
    background: palette.background,
    // @theming labelText: Dropdown box shadow, type: string
    boxShadow: '0 0 10px 0 rgba(0,0,0,0.3)',
    // @theming labelText: Dropdown padding, type: pixel
    padding: 20,
  },
  // @theming labelText: Day border radius, type: pixel
  dayBorderRadius: 100,

  // Calendar Days
  // @theming labelText: Day hover background color, type: color
  dayHoverBackground: palette.grey.G100,

  dayNames: {
    // @theming labelText: Calendar header cell font size, type: pixel
    fontSize: 10,
  },
  // @theming labelText: Disable day text color, type: color, backgroundColor: datepickerReact.background
  disabledDate: 'rgba(0,0,0,0.1)',
  // @theming labelText: Focus outline color, type: color
  focusColor: palette.focus.normal,
  // @theming labelText: Datepicker font family, type: fontFamily
  fontFamily: typography.fontFamily,
  // @theming labelText: Caret icon color, type: color
  iconFill: palette.text.dark,
  // @theming labelText: Caret icon hover color, type: color
  iconFillHover: palette.text.midGray,
  // TODO: Remove unused
  inRange: palette.text.dark,
  // @theming labelText: In range day background color, type: color
  inRangeBackground: '#cbe4ff',

  input: {
    // @theming labelText: Input background color, type: color
    backgroundColor: palette.background,
    // @theming labelText: Input text color, type: color, backgroundColor: datepickerReact.input.backgroundColor
    color: palette.text.dark,
    dark: {
      // @theming labelText: Input dark background color, type: color
      backgroundColor: 'inherit',
      // @theming labelText: Input dark text color, type: color, backgroundColor: datepickerReact.input.dark.backgroundColor
      color: palette.text.light,
    },
  },
  // TODO: Remove unused
  inputBorderRadius: 2,
  // @theming labelText: Margin on the top or bottom of the dropdown, type: pixel
  inputHeight: 40,

  // @theming labelText: Text input icon color, type: color
  inputIconButtonColor: palette.primary.normal,

  inputWrapper: {},

  // Select day/period
  isToday: {
    // TODO: not really sure what to do here. This property is spread into Day
    '&::before': {
      borderRadius: '50%',
      boxShadow: `0 0 0 1px ${palette.primary.normal}`,
      content: '""',
      height: 24,
      left: '50%',
      position: 'absolute',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      width: 24,
    },
  },
  // @theming labelText: Margin on the bottom of the dropdown, type: pixel
  labelHeight: 15,
  // @theming labelText: Breakpoint for when to stack the calendars, type: pixel
  mobileBreakpoint: 800,

  monthSelectButton: {},

  monthSelectIcon: {},

  // Select month
  // TODO: Property is spread
  monthSelectTitle: {
    // @theming labelText: Calendar month/year text color, type: color, backgroundColor: datepickerReact.dateSelect.background
    color: palette.text.dark,
    // @theming labelText: Calendar month/year font family, type: fontFamily
    fontFamily: `"Roboto Condensed", ${typography.fontFamily}`,
    // @theming labelText: Calendar month/year text size, type: pixel
    fontSize: 20,
    // @theming labelText: Calendar month/year line height, type: string
    lineHeight: '28px',
    // @theming labelText: Calendar month/year text alignment, type: string
    textAlign: 'center',
    // @theming labelText: Calendar month/year text transform, type: string
    textTransform: 'uppercase',
  },

  // Month and Year dropdown
  monthYearDropdown: {
    // @theming labelText: Border for timepicker, year, and month select, type: string
    border: `1px solid ${palette.form.border}`,
  },

  monthYearDropdownCaret: {
    // @theming labelText: Caret left for timepicker, year, and month select, type: string
    left: '50%',
    // @theming labelText: Caret top for timepicker, year, and month select, type: string
    top: '50%',
  },

  period: {
    // @theming labelText: Margin for in range day, type: string
    margin: [4, 'auto'],
  },

  // Range Panel
  // TODO: remove always overridden
  rangePanelBackground: palette.highlightBackground,
  // TODO: Remove un-used
  rangePanelBorder: palette.form.border,
  // @theming labelText: Range dropdown hover color, type: color
  rangePanelHover: palette.highlightBackground,

  // Calendar wrapper
  rangeSelect: {
    // @theming labelText: Range dropdown background color, type: color
    background: palette.background,
    // @theming labelText: Range dropdown border, type: string
    border: `1px solid ${palette.form.border}`,
  },
  // @theming labelText: Range option selected background color, type: color
  selected: palette.primary.normal,
  // @theming labelText: Range option selected text color, type: color, backgroundColor: datepickerReact.selected
  selectedText: palette.text.light,
  // @theming labelText: Dropdown text color, type: color, backgroundColor: datepickerReact.dateSelect.background
  text: palette.text.dark,

  textInput: {
    // @theming labelText: Input padding right, type: pixel
    paddingRight: 30,
  },

  textInputToggle: {
    // @theming labelText: Toggle position right, type: pixel
    right: 3,
    // @theming labelText: Toggle position top, type: pixel
    top: 19,
  },

  // Select time
  timepickerLabel: {
    // @theming labelText: Timepicker label color, type: color, backgroundColor: datepickerReact.timepickerWrapper.backgroundColor
    color: palette.grey.G600,
    // @theming labelText: Timepicker text transform, type: string
    textTransform: 'uppercase',
  },

  timepickerWrapper: {
    // @theming labelText: Timepicker background color, type: color
    backgroundColor: palette.background,
    // @theming labelText: Timepicker border, type: string
    border: `1px solid ${palette.form.border}`,
  },
  // TODO: Remove un-used
  todayBorder: palette.primary.normal,
  // TODO: Remove unused
  weekHeader: palette.grey.G300,
  // Week numbers
  weekNumber: {
    // @theming labelText: Week day number color, type: color, backgroundColor: datepickerReact.dateSelect.background
    color: palette.grey.G300,
    // @theming labelText: Week day font size, type: pixel
    fontSize: 16,
    // @theming labelText: Week day line height, type: string
    lineHeight: '26px',
  },
});
